export function user(state) {
  return state.user;
}
export function isLoggedIn(state) {
  return !!state.user.id;
}
export function roles(state) {
  return state.user.roles;
}
export function permissions(state) {
  return state.user.permissions;
}